import React, {useEffect, useRef, useState} from "react";
import {InputNumber, Space, Tag} from "antd";
import { PlusOutlined } from '@ant-design/icons';
import {WidgetProps} from "../widget";

const tagInputStyle: React.CSSProperties = {
    width: 64,
    height: 22,
    marginInlineEnd: 8,
    verticalAlign: 'top',
};

export const UIInputWidgetInputTags: React.FC<WidgetProps> = ({value, onChange, loading}) => {

    const [tags, setTags] = useState<number[]>(value as any || []);
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState<number | null>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputVisible) {
            inputRef.current?.focus();
        }
    }, [inputVisible]);

    const handleClose = (removedTag: number) => {
        const newTags = tags.filter((tag) => tag !== removedTag);
        setOrderedTags(newTags);
    };

    const showInput = () => {
        setInputVisible(true);
    };

    const handleInputChange = (value: number | null) => {
        setInputValue(value);
    };

    const handleInputConfirm = () => {
        if (inputValue && !tags.includes(inputValue)) {
            const newValue = [...tags, inputValue];
            setOrderedTags(newValue);
        }
        setInputVisible(false);
        setInputValue(null);
    };

    const setOrderedTags = (tags: number[]) => {
        tags.sort((x, y) => x - y)
        setTags(tags)
        if (onChange) {
            onChange(tags as any)
        }
    }

    const tagPlusStyle: React.CSSProperties = {
        height: 22,
        borderStyle: 'dashed',
    };

    return (
        <Space size={[2,2]}>
            {tags.map<React.ReactNode>((tag, index) => (
                <Tag
                    key={tag}
                    closable
                    onClose={() => handleClose(tag)}
                >
                    {tag}
                </Tag>
            ))}
            {inputVisible ? (
                <InputNumber<number>
                    min={0}
                    max={23}
                    ref={inputRef}
                    type="text"
                    size="small"
                    style={tagInputStyle}
                    value={inputValue as number}
                    onChange={handleInputChange}
                    onBlur={handleInputConfirm}
                    onPressEnter={handleInputConfirm}
                    placeholder={"0-23"}
                    controls={false}
                />
            ) : (
                <Tag style={tagPlusStyle} icon={<PlusOutlined />} onClick={showInput} color={"blue"}>
                    Add hour
                </Tag>
            )}
        </Space>
    );

}